import logger from './logger';

const formatRelativeTime = (timestamp, now = Date.now()) => {
  if (!timestamp) return null;
  let ts = typeof timestamp === 'string' ? new Date(timestamp).getTime() : Number(timestamp);
  if (!Number.isFinite(ts)) return null;
  if (ts > now) {
    logger.warn('[TIME] timestamp is in the future, clamping to now', {
      deltaMs: Math.round(ts - now)
    });
    ts = now;
  }

  const diff = now - ts;
  const minutes = Math.round(diff / 1000 / 60);
  const hours = Math.round(diff / 1000 / 60 / 60);

  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  return new Date(ts).toLocaleDateString();
};

const monthKeyFromDate = (dateStr) => {
  if (!dateStr) return null;
  if (/^\d{4}-\d{2}/.test(dateStr)) return dateStr.slice(0, 7);
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

export { formatRelativeTime, monthKeyFromDate };
